module.exports = __webpack_public_path__ + "2ca824d367a602a825bda7e04d141854.svg";